import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { categories, allMovies, MovieItem } from '@/mocks/movies';
import Breadcrumb from '@/components/feature/Breadcrumb';
import MovieCard from '@/components/base/MovieCard';
import PageSEO from '@/components/base/PageSEO';
import { getWebPageSchema, getBreadcrumbSchema } from '@/mocks/seo';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'all');
  const [filteredMovies, setFilteredMovies] = useState<MovieItem[]>([]);

  const currentCategory = categories.find(c => c.slug === activeSlug);
  const categoryName = currentCategory?.name || '全部分类';

  useEffect(() => {
    setActiveSlug(slug || 'all');
  }, [slug]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (activeSlug === 'all') {
      setFilteredMovies(allMovies);
    } else {
      setFilteredMovies(allMovies.filter(m => m.categorySlug === activeSlug));
    }
  }, [activeSlug]);

  return (
    <>
      <PageSEO
        schemas={[
          getWebPageSchema(
            `${categoryName} - 春色影视高清在线观看`,
            `春色影视${categoryName}分类，高清免费在线观看，不缓冲流畅播放，秒开无卡顿极速影视体验。`,
            `https://chunseys.com/category/${activeSlug}`,
          ),
          getBreadcrumbSchema([
            { name: '首页', url: 'https://chunseys.com/' },
            { name: categoryName, url: `https://chunseys.com/category/${activeSlug}` },
          ]),
        ]}
      />
      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: currentCategory?.name || '全部分类' },
          ]}
        />

        <section className="w-full px-4 md:px-6 py-6 md:py-10">
          <div className="max-w-7xl mx-auto">
            <h1 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
              {currentCategory?.name || '全部分类'}
            </h1>
            <p className="text-sm text-foreground-500 mb-6">探索你喜爱的影视内容，高清流畅在线观看</p>

            <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2 flex-wrap">
              {categories.map((cat) => (
                <a
                  key={cat.slug}
                  href={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-300 cursor-pointer ${
                    activeSlug === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900'
                  }`}
                >
                  {cat.name}
                </a>
              ))}
            </div>

            {filteredMovies.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
                {filteredMovies.map((movie) => (
                  <MovieCard key={movie.id} movie={movie} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-100 mb-4">
                  <i className="ri-movie-line text-2xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-500">暂无该分类的影视内容</p>
              </div>
            )}
          </div>
        </section>
      </main>
    </>
  );
}